module.exports = __webpack_public_path__ + "img/logotitle.a7f0a64f.png";